import type { EmailCrawlerProcessorType } from './email-crawler-api';

export interface KnownCrawlerFolder {
  prefix: string;
  sourceKey: string;
  processorType: EmailCrawlerProcessorType;
}

export const KNOWN_CRAWLER_FOLDERS: readonly KnownCrawlerFolder[] = [
  {
    prefix: 'kho_ban_lanh_dao/',
    sourceKey: 'dashboard-main',
    processorType: 'email_dashboard',
  },
  {
    prefix: 'kho_tuyen_dung/',
    sourceKey: 'recruitment-dungquat',
    processorType: 'recruitment',
  },
] as const;

export function findKnownCrawlerFolder(prefix: string | null): KnownCrawlerFolder | null {
  if (!prefix) return null;
  return (
    KNOWN_CRAWLER_FOLDERS.find(
      (folder) => prefix === folder.prefix || prefix.startsWith(folder.prefix),
    ) ?? null
  );
}
